module.exports = __webpack_public_path__ + "static/en-29137a974108f827f3bc20c27ae8b321.svg";